/**
 * Core Alert — Theme-aware alert/notification banner.
 */
import React from 'react';
import { Alert as MuiAlert, AlertTitle } from '@mui/material';

export interface AlertProps {
  severity?: 'success' | 'info' | 'warning' | 'error';
  title?: string;
  children: React.ReactNode;
  onClose?: () => void;
  className?: string;
  action?: React.ReactNode;
}

export const Alert: React.FC<AlertProps> = ({ severity = 'info', title, children, onClose, className, action }) => (
  <MuiAlert severity={severity} onClose={onClose} action={action} className={className} sx={{ mb: 2 }}>
    {title && <AlertTitle>{title}</AlertTitle>}
    {children}
  </MuiAlert>
);
export default Alert;
